import { render, staticRenderFns } from "./emotional-question.vue?vue&type=template&id=5573e6ec"
import script from "./emotional-question.vue?vue&type=script&lang=js"
export * from "./emotional-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports